const compatModules = {};import * as Mod1 from "./discourse-markdown/waze-markdown";
compatModules["discourse-markdown/waze-markdown"] = Mod1;

export * as discourse__markdown$waze__markdown$$__module from "./discourse-markdown/waze-markdown";
export {
setup as discourse__markdown$waze__markdown$$setup
} from "./discourse-markdown/waze-markdown";
export default compatModules;
